import { z } from "zod";
import { AssetStateSchema } from "@/types/State";
import { orderable } from "@/util/ordering";

const stateFiltersSchema = z.object({
  zone: z.number().min(1).max(5).array().optional(),
  drCriticality: z.number().min(1).max(5).array().optional(),
  hms1Criticality: z.number().min(1).max(5).array().optional(),
  hms3Criticality: z.number().min(1).max(5).array().optional(),
  ipType: z.string().array().optional(),
  state: z.number().min(1).max(5).array().optional(),
  system: z.string().array().optional(),
  page: z.number().min(1).default(1),
  order: orderable(AssetStateSchema.omit({ comment: true, lifespan_years: true })).default(
    "ip_type",
  ),
  onlyDeviations: z.boolean().default(false),
  assetGroup: z.string().array().optional(),
});

export type StateFilters = z.infer<typeof stateFiltersSchema>;
export type StateSearchType = z.infer<typeof stateSearchSchema>;

export const stateSearchSchema = z.object({
  state: stateFiltersSchema.default({
    page: 1,
    order: "ip_type",
    onlyDeviations: false,
  }),
});
